import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

import { Chip } from '@mui/material';

const useStyles = makeStyles({
  root: {
    background: 'linear-gradient(90deg, #4A90E2, #50C9C3)',
    color: '#fff',
    height: 25,
    marginLeft: 'auto',
  },
});

const ExperimentalChip = () => {
  const classes = useStyles();
  return <Chip className={classes.root} label="experimental" />;
};

export default ExperimentalChip;
